import { type FC } from "react";

import { t } from "i18n/i18n";
import { DropdownMenu } from "mds/components/DropdownMenu";
import { FolderIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import { courseGroupingSelectors } from "store/selectors/base";
import { ADMIN_COURSE_EVENT_PREFIX } from "utils/amplitude";

type CourseGroupingDropdownProps = {
  selectedGroupingId: string | null;
  onSelectionChange: (groupingId: string | null) => void;
};

export const CourseGroupingDropdown: FC<CourseGroupingDropdownProps> = ({
  selectedGroupingId,
  onSelectionChange,
}) => {
  const groupings = useAppSelector(courseGroupingSelectors.selectAll);

  const dropdownItems = [
    {
      id: "",
      title: t("home.courses.select_a_grouping"),
    },
    ...groupings.map((grouping) => ({
      id: grouping.id,
      title: grouping.title,
      iconStart: <FolderIcon />,
    })),
  ];

  return (
    <DropdownMenu
      buttonText={
        !selectedGroupingId ? (
          <div className="text-sm font-medium">{t("home.courses.select_a_grouping")}</div>
        ) : undefined
      }
      className="flex w-full items-center !justify-between"
      eventName={`${ADMIN_COURSE_EVENT_PREFIX}Add Course - Select Folder`}
      items={dropdownItems}
      selectedValue={selectedGroupingId || ""}
      truncateWidth="max-w-full"
      onSelectionChange={(item) => {
        onSelectionChange(item.id === "" ? null : item.id);
      }}
    />
  );
};
